import { createSlice } from "@reduxjs/toolkit";

const initialState = { info: {} };

const userSessionSlice = createSlice({
  name: "userSession",
  initialState,
  reducers: {
    setSessionData(state, { payload }) {
      state.info = payload;
    },
    resetSessionData(state) {
      state.info = initialState.info;
    },
  },
});

export const { setSessionData, resetSessionData } = userSessionSlice.actions;
export default userSessionSlice.reducer;
